webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(277)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(207),
  /* template */
  __webpack_require__(1087),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1067:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(269)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(1080),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1068:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(275)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(210),
  /* template */
  __webpack_require__(1085),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1069:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(271)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(1082),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1070:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(266)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(212),
  /* template */
  __webpack_require__(1077),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1071:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(268)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(213),
  /* template */
  __webpack_require__(1079),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1072:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(276)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(214),
  /* template */
  __webpack_require__(1086),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1073:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(278)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(215),
  /* template */
  __webpack_require__(1088),
  /* scopeId */
  "data-v-f0322f3c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1074:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(267)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(216),
  /* template */
  __webpack_require__(1078),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1075:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(274)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(217),
  /* template */
  __webpack_require__(1084),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1076:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(270)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(218),
  /* template */
  __webpack_require__(1081),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1077:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    attrs: {
      "id": "foot"
    }
  }, [_c('p', [_vm._v("Because Trump is 💩, "), _vm._t("default", [_vm._v("Seriously, WTF")]), _c('a', {
    staticClass: "top",
    class: {
      'show': _vm.showScroll
    },
    attrs: {
      "id": "scroller",
      "href": "#ftl"
    },
    on: {
      "click": _vm.scrollUp
    }
  }, [_c('icon', {
    attrs: {
      "name": "arrow-up",
      "scale": "1"
    }
  })], 1)], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 1078:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.filtered.length) ? _c('div', {
    staticClass: "rss"
  }, [_c('h2', {
    staticClass: "pointer shadow-text",
    class: {
      'collapsed': _vm.collapsed
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.destinationUrl
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]), (_vm.collapsed) ? _c('span', {
    staticClass: "expando",
    on: {
      "click": function($event) {
        _vm.collapsed = !_vm.collapsed
      }
    }
  }, [_vm._v(" …")]) : _c('span', {
    staticClass: "expando",
    on: {
      "click": function($event) {
        _vm.collapsed = !_vm.collapsed
      }
    }
  }, [_vm._v(" ⇐")])]), (_vm.busy) ? _c('icon', {
    attrs: {
      "name": "refresh",
      "scale": "3",
      "spin": "spin"
    }
  }) : _vm._e(), _c('ul', _vm._l((_vm.filtered), function(post) {
    return (!_vm.collapsed && post) ? _c('li', {
      staticClass: "post"
    }, [_c('a', {
      attrs: {
        "href": post.link
      }
    }, [(post) ? _c('span', [_vm._v(_vm._s(_vm.decodeHtml(post.title)))]) : _vm._e()]), (_vm.hide !== 'description') ? _c('p', [(post.pic && post.descriptionLength < 600) ? _c('small', {
      domProps: {
        "innerHTML": _vm._s(post.description)
      }
    }) : _vm._e()]) : _vm._e()]) : _vm._e()
  }))], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1079:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, [_c('rss', {
    attrs: {
      "destination-url": "https://www.reddit.com/r/esist",
      "feed-url": "https://www.reddit.com/r/esist.rss",
      "title": "Reddit:r/esist",
      "hide": "description"
    }
  }), _c('rss', {
    attrs: {
      "destination-url": "https://www.reddit.com/r/worldnews",
      "feed-url": "https://www.reddit.com/r/worldnews.rss",
      "title": "Reddit:r/WorldNews",
      "hide": "description"
    }
  }), _c('rss', {
    attrs: {
      "destination-url": "https://www.reddit.com/r/politics",
      "feed-url": "https://www.reddit.com/r/politics.rss",
      "title": "Reddit:r/Politics"
    }
  }), _c('rss', {
    attrs: {
      "destination-url": "https://fivethirtyeight.com/politics",
      "feed-url": "https://fivethirtyeight.com/politics/feed/",
      "title": "538:Politics"
    }
  }), _c('rss', {
    attrs: {
      "destination-url": "http://thehill.com/homenews/administration",
      "feed-url": "http://thehill.com/taxonomy/term/1132/feed",
      "title": "TheHill:Administration"
    }
  }), _c('rss', {
    attrs: {
      "destination-url": "https://www.reddit.com/r/TrumpCriticizesTrump",
      "feed-url": "https://www.reddit.com/r/TrumpCriticizesTrump.rss",
      "title": "Reddit:r/TrumpCritcizesTrump",
      "includes": "",
      "hide": "description"
    }
  }), _c('rss', {
    attrs: {
      "destination-url": "https://www.reddit.com/r/liestrumptoldus",
      "feed-url": "https://www.reddit.com/r/liestrumptoldus.rss",
      "title": "Reddit:r/liestrumptoldus",
      "hide": "description"
    }
  }), _c('rss', {
    attrs: {
      "destination-url": "http://politico.com",
      "feed-url": "http://www.politico.com/rss/politicopicks.xml",
      "title": "Politico:Politics"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1080:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Today, " + _vm._s(_vm.today) + ":")]), _c('p', [_vm._v("Donald Trump is on 🔥 with an approval rating of "), _c('span', {
    staticClass: "approve"
  }, [_vm._v(_vm._s(Number(_vm.dataToday.approve_estimate).toFixed(1)) + "%")]), _c('span', [_vm._v(" and disapproval of ")]), _c('span', {
    staticClass: "disapprove"
  }, [_vm._v(_vm._s(Number(_vm.dataToday.disapprove_estimate).toFixed(1)) + "%")])]), _c('p', [(_vm.busy) ? _c('icon', {
    attrs: {
      "name": "refresh",
      "scale": "3",
      "spin": "spin"
    }
  }) : _vm._e()], 1), (_vm.dataToday.approve_estimate < 60) ? _c('p', [_vm._v("A great big"), _c('span', {
    staticStyle: {
      "color": "#F00",
      "text-transform": "uppercase"
    }
  }, [_vm._v(" Fail!!")])]) : _vm._e(), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "target": "_blank",
      "rel": "noopener",
      "href": "https://projects.fivethirtyeight.com/trump-approval-ratings/"
    }
  }, [_vm._v("Trump Approvial Ratings ")]), _c('sup', [_vm._v("@538")])])
}]}

/***/ }),

/***/ 1081:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-level"
  }, [_c('form', {
    attrs: {
      "name": "contact",
      "netlify": ""
    }
  }, [_c('p', [_c('label', [_vm._v("Your Name: "), _c('input', {
    attrs: {
      "type": "text",
      "name": "name"
    }
  })])]), _vm._v(" "), _c('p', [_c('label', [_vm._v("Your Email: "), _c('input', {
    attrs: {
      "type": "email",
      "name": "email"
    }
  })])]), _vm._v(" "), _c('p', [_c('label', [_vm._v("Message: "), _c('textarea', {
    attrs: {
      "name": "message"
    }
  })])]), _vm._v(" "), _c('p', [_c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Send")])])])])
}]}

/***/ }),

/***/ 1082:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("It's been " + _vm._s(_vm.days.served) + " days since this dumpster 🔥 of a Presidency began...")]), _c('h1', [_vm._v("There are " + _vm._s(_vm.days.left) + " days left. The term is only " + _vm._s((_vm.days.served / _vm.days.term).toFixed(2) * 100) + "% over... 😰")])])
},staticRenderFns: []}

/***/ }),

/***/ 1083:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('global-nav'), _c('div', {
    staticClass: "container"
  }, [_c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1), _c('foot', [_c('b', [_c('a', {
    attrs: {
      "href": "https://projects.fivethirtyeight.com/trump-approval-ratings/",
      "target": "_blank"
    }
  }, [_vm._v("Trump Approval Ratings ")])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1084:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comment"
  }, [(_vm.busy) ? _c('icon', {
    attrs: {
      "name": "refresh",
      "scale": "3",
      "spin": "spin"
    }
  }) : _vm._e(), _c('div', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "href": _vm.comment.permalink,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.comment.title))])]), _c('div', {
    staticClass: "quote"
  }, [_c('blockquote', {
    domProps: {
      "innerHTML": _vm._s(_vm.decodeHtml(_vm.comment.text))
    }
  })], 1), _c('div', {
    staticClass: "comment__foot"
  }, [_c('div', [_c('span', [_vm._v("~ ")]), _c('a', {
    attrs: {
      "href": ("https://reddit.com/u/" + (_vm.comment.author)),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.comment.author))])]), _c('div', [_c('ul', {
    staticClass: "sendoff"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": _vm.comment.context,
      "target": "_blank"
    }
  }, [_vm._v("[article]")])])])])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1085:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-level"
  }, [_c('h1', [_vm._v("Straight Fire 🔥")]), _c('p', [_vm._v("Trolling the internet for the best burns")]), _c('p', [_vm._v(" ")]), _c('c', {
    attrs: {
      "u": "https://www.reddit.com/r/esist/comments/6rkj9n/hes_the_opposite_of_teddy_roosevelt_a_former/dl5y15w/"
    }
  }), _c('c', {
    attrs: {
      "u": "https://www.reddit.com/r/politics/comments/6qzwd7/trump_told_golf_club_members_that_the_white_house/dl19wvc/"
    }
  }), _c('c', {
    attrs: {
      "u": "https://www.reddit.com/r/politics/comments/6r5v2t/poll_trump_hits_new_low_at_33_percent_approval/dl2ip3q/"
    }
  }), _c('c', {
    attrs: {
      "u": "https://www.reddit.com/r/worldnews/comments/6c5ovz/nytimes_trump_told_russians_that_firing_nut_job/dhs50di/"
    }
  }), _c('c', {
    attrs: {
      "u": "https://www.reddit.com/r/worldnews/comments/6bv4f9/trump_campaign_had_at_least_18_undisclosed/dhprbfv/"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1086:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-level"
  }, [_c('h1', [_vm._v("Hot Stove")]), _c('div', {
    staticClass: "embed-grid"
  }, [_vm._m(0), _vm._m(1), _vm._m(2), _c('div', {
    staticClass: "embedded"
  }, [_c('youtube', {
    attrs: {
      "video-id": 'W-Q671j1MO4',
      "player-width": "384",
      "player-height": "240"
    }
  }), _vm._m(3)], 1), _c('div', {
    staticClass: "embedded"
  }, [_c('tweet-embed', {
    attrs: {
      "id": '882186896285282304'
    }
  }), _vm._m(4)], 1), _c('div', {
    staticClass: "embedded"
  }, [_c('tweet-embed', {
    attrs: {
      "id": '883829926993862656'
    }
  }), _vm._m(5)], 1), _c('div', {
    staticClass: "embedded"
  }, [_c('youtube', {
    attrs: {
      "video-id": 'UucY6LmTkrI',
      "player-width": "384",
      "player-height": "240"
    }
  }), _vm._m(6)], 1), _c('div', {
    staticClass: "embedded"
  }, [_c('youtube', {
    attrs: {
      "video-id": 'FVFdsl29s_Q',
      "player-width": "384",
      "player-height": "240"
    }
  }), _vm._m(7)], 1), _c('div', {
    staticClass: "embedded"
  }, [_c('youtube', {
    attrs: {
      "video-id": '4497ZM_d3cs',
      "player-width": "384",
      "player-height": "240"
    }
  }), _vm._m(8)], 1), _c('div', {
    staticClass: "embedded"
  }, [_c('youtube', {
    attrs: {
      "video-id": 'RnfYF_RTEc0',
      "player-width": "384",
      "player-height": "240"
    }
  }), _vm._m(9)], 1), _c('div', {
    staticClass: "embedded"
  }, [_c('tweet-embed', {
    attrs: {
      "id": '864631567972540417'
    }
  }), _vm._m(10)], 1), _c('div', {
    staticClass: "embedded"
  }, [_c('tweet-embed', {
    attrs: {
      "id": '474134260149157888'
    }
  }), _vm._m(11)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "embedded"
  }, [_c('img', {
    staticClass: "pic",
    attrs: {
      "src": "/static/RLAuOZT.gif"
    }
  }), _c('p', [_c('small', [_vm._v("TTTTrump's America")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "embedded"
  }, [_c('img', {
    staticClass: "pic",
    attrs: {
      "src": "/static/usa-trump-giant-rat.jpg"
    }
  }), _c('p', [_c('small', [_vm._v("NYC Welcome Home")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "embedded"
  }, [_c('img', {
    staticClass: "pic",
    attrs: {
      "src": "/static/hair.jpg"
    }
  }), _c('p', [_c('small', [_vm._v("Hairswap")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('small', [_vm._v("MOOOOOCH")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('small', [_vm._v("WTF is this?! Sounds Hitlertastic")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('small', [_vm._v("This is the best burn to date. Austrailia with a reality check.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('small', [_vm._v("Bernie Busting Budgets")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('small', [_vm._v("Great summary of this insane Presidency")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('small', [_vm._v("WH built on lies, caving in.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('small', [_vm._v("Strong marriage they've got there..")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('small', [_vm._v("Turkish strongmen attack protestors in Washington, DC")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('small', [_vm._v("Hypocritical")])])
}]}

/***/ }),

/***/ 1087:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: _vm.clazz,
    style: (_vm.style),
    attrs: {
      "version": "1.1",
      "role": _vm.label ? 'img' : 'presentation',
      "aria-label": _vm.label,
      "x": _vm.x,
      "y": _vm.y,
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.box
    }
  }, [_vm._t("default", [(_vm.icon && _vm.icon.paths) ? _vm._l((_vm.icon.paths), function(path) {
    return _c('path', _vm._b({}, 'path', path))
  }) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.icon.polygons) ? _vm._l((_vm.icon.polygons), function(polygon) {
    return _c('polygon', _vm._b({}, 'polygon', polygon))
  }) : _vm._e(), _vm._v("\b\n    "), (_vm.icon && _vm.icon.raw) ? [_c('g', {
    domProps: {
      "innerHTML": _vm._s(_vm.icon.raw)
    }
  })] : _vm._e()])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1088:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [_c('ul', [_c('li', {
    staticClass: "pull-left"
  }, [_c('h1', {
    staticClass: "header shadow-text"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Trump "), _c('abbr', {
    attrs: {
      "title": "For The Loss"
    }
  }, [_vm._v("FTL")])])], 1)]), _c('li', {
    staticClass: "media"
  }, [_c('router-link', {
    staticClass: "shadow-text",
    attrs: {
      "to": {
        path: '/latest'
      },
      "title": "Hot Stove"
    }
  }, [_c('icon', {
    attrs: {
      "name": "camera",
      "scale": "3",
      "color": "#333"
    }
  })], 1)], 1), _c('li', {
    staticClass: "comments"
  }, [_c('router-link', {
    staticClass: "shadow-text",
    attrs: {
      "to": {
        path: '/burnnn'
      },
      "title": "Burn Notice"
    }
  }, [_c('icon', {
    attrs: {
      "name": "fire",
      "scale": "3",
      "color": "#333"
    }
  })], 1)], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Days__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Days___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Days__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Burn__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Burn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Burn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Submission__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Submission___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Submission__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_HotStove__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_HotStove___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_HotStove__);









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a
  }, {
    path: '/submission',
    name: 'Submission',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Submission___default.a
  }, {
    path: '/burnnn',
    name: 'Burn',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Burn___default.a
  }, {
    path: '/latest',
    name: 'HotStove',
    component: __WEBPACK_IMPORTED_MODULE_6__components_HotStove___default.a
  }, {
    path: '/days',
    name: 'Days',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Days___default.a
  }, {
    path: '*',
    redirect: '/'
  }]
}));

/***/ }),

/***/ 187:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(272)
__webpack_require__(273)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(208),
  /* template */
  __webpack_require__(1083),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_awesome_icons_refresh__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_awesome_icons_arrow_up__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_awesome_icons_video_camera__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_awesome_icons_comment__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_awesome_icons_pencil__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_icons__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_components_Icon_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_components_Icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_awesome_components_Icon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_youtube_embed__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_youtube_embed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_youtube_embed__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.axios = __WEBPACK_IMPORTED_MODULE_3_axios___default.a;









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('icon', __WEBPACK_IMPORTED_MODULE_10_vue_awesome_components_Icon_vue___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vue_youtube_embed___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin({
  data: function data() {
    return {
      days: 0,
      pageName: ''
    };
  },

  watch: {
    '$route': function $route(to, from) {
      this.pageName = to.name;
    }
  },
  methods: {},
  created: function created() {
    Date.dateDiff = function (datepart, fromdate, todate) {
      datepart = datepart.toLowerCase();
      var diff = todate - fromdate;
      var divideBy = {
        w: 604800000,
        d: 86400000,
        h: 3600000,
        n: 60000,
        s: 1000
      };

      return Math.floor(diff / divideBy[datepart]);
    };
    var today = new Date();
    var start = new Date('2017/01/20');
    var end = new Date('2021/01/20');
    var served = Date.dateDiff('d', start, today);
    var left = Date.dateDiff('d', today, end);
    var term = Date.dateDiff('d', start, end);
    this.days = {};
    this.days.served = served;
    this.days.remaining = (served / term * 100).toFixed(1);
    this.timer = {
      served: served,
      left: left,
      term: term,
      today: today,
      start: start,
      end: end
    };
  }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#ftl',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 207:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);




var icons = {};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val) {
          if (!(val in icons)) {
            __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].util.warn('Invalid prop: prop "icon" is referring to an unregistered icon "' + val + '".' + '\nPlesase make sure you have imported this icon before using it.', this);
            return false;
          }
          return true;
        }
        return null;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].util.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    clazz: function clazz() {
      return {
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse
      };
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.icon) {
      return;
    }
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;
    });
    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

/***/ }),

/***/ 208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Footer__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    'global-nav': __WEBPACK_IMPORTED_MODULE_0__components_Nav___default.a,
    Foot: __WEBPACK_IMPORTED_MODULE_1__components_Footer___default.a
  },
  data: function data() {
    return {
      transition: 'fade'
    };
  }
});

/***/ }),

/***/ 209:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'approval',
  data: function data() {
    return {
      approvalData: null,
      busy: true,
      todayDataFormat: __WEBPACK_IMPORTED_MODULE_2_moment__().format('YYYY-MM-DD'),
      today: __WEBPACK_IMPORTED_MODULE_2_moment__().format('MMM, Do, YYYY'),
      dataToday: {},
      approve: '',
      disapprove: ''
    };
  },

  methods: {
    currentApproval: function currentApproval(approval) {
      return approval.date === this.todayDataFormat && approval.subgroup === 'All polls';
    },
    getApproval: function getApproval() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var url, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = 'https://projects.fivethirtyeight.com/trump-approval-ratings/approval.json';
                _context.next = 3;
                return fetch(url);

              case 3:
                response = _context.sent;
                _context.next = 6;
                return response.json();

              case 6:
                _this.approvalData = _context.sent;

                _this.dataToday = _this.approvalData.filter(_this.currentApproval)[0];
                _context.next = 10;
                return false;

              case 10:
                _this.busy = _context.sent;

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  created: function created() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this2.getApproval();

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),

/***/ 210:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RedditComment__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RedditComment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__RedditComment__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Burn',
  components: {
    'c': __WEBPACK_IMPORTED_MODULE_0__RedditComment___default.a
  }
});

/***/ }),

/***/ 211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'days'
});

/***/ }),

/***/ 212:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_smooth_scroll__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_smooth_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_smooth_scroll__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'footer',
  data: function data() {
    return {
      showScroll: false
    };
  },

  methods: {
    scrollUp: function scrollUp(e) {
      e.preventDefault();
      var scroll = new __WEBPACK_IMPORTED_MODULE_0_smooth_scroll___default.a();
      var anchor = document.querySelector('#scroller');
      var toggle = document.querySelector('#ftl');
      var options = { speed: 1000, easing: 'easeOutCubic' };
      scroll.animateScroll(anchor, toggle, options);
    },
    handleScroll: function handleScroll() {
      var scrollTop = window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
      if (scrollTop > 100) {
        this.showScroll = true;
      } else {
        this.showScroll = false;
      }
    }
  },
  created: function created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
});

/***/ }),

/***/ 213:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Approval__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Approval___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Approval__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RSS__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RSS___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__RSS__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  components: {
    Approval: __WEBPACK_IMPORTED_MODULE_0__Approval___default.a,
    Rss: __WEBPACK_IMPORTED_MODULE_1__RSS___default.a
  },
  data: function data() {
    return {};
  },
  created: function created() {
    this.pageName = 'Home';
  },

  methods: {},
  mounted: function mounted() {}
});

/***/ }),

/***/ 214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_tweet_embed__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_tweet_embed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_tweet_embed__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hotstove',
  data: function data() {
    return {};
  },

  components: {
    'tweet-embed': __WEBPACK_IMPORTED_MODULE_0_vue_tweet_embed___default.a
  }
});

/***/ }),

/***/ 215:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'nav',
  data: function data() {
    return {
      pageName: this.$route.name
    };
  }
});

/***/ }),

/***/ 216:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'rss',
  props: {
    destinationUrl: { type: String },
    feedUrl: { required: true },
    title: { required: true },
    includes: { default: 'Trump' },
    collapsed: { default: false },
    hide: null
  },
  data: function data() {
    return {
      posts: { items: [] },
      errors: null,
      filtered: [],
      busy: true
    };
  },

  computed: {},
  methods: {
    decodeHtml: function decodeHtml(html) {
      html = html.replace(/&amp;#039;/gi, '\'');
      var txt = document.createElement('textarea');
      txt.innerHTML = html;
      var val = txt.value;

      return val;
    }
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var rssApi, response;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              rssApi = 'https://api.rss2json.com/v1/api.json?rss_url=' + encodeURIComponent(_this.feedUrl);
              _context.next = 4;
              return _this.axios.get(rssApi);

            case 4:
              response = _context.sent;

              _this.posts = response.data;
              setTimeout(function () {
                _this.filtered = _this.posts.items.filter(function (post) {
                  post.descriptionLength = post.description.length;
                  post.pic = !!(post.description.indexOf('<img') >= 0);
                  var re = new RegExp(_this.includes, 'gi');
                  return !!(post.title.match(re) && post.title.match(re).length);
                });
                _this.busy = false;
              });
              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context['catch'](0);

              _this.errors.push(_context.t0);

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[0, 9]]);
    }))();
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ 217:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);






var RedditFetcher = function () {
  function RedditFetcher() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, RedditFetcher);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(RedditFetcher, [{
    key: 'fetchComment',
    value: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(url) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch(url);

              case 2:
                response = _context.sent;
                _context.next = 5;
                return response.json();

              case 5:
                return _context.abrupt('return', _context.sent);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchComment(_x) {
        return _ref.apply(this, arguments);
      }

      return fetchComment;
    }()
  }]);

  return RedditFetcher;
}();

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    u: { type: String, required: true }
  },
  data: function data() {
    return {
      busy: true,
      jsonUrl: '',
      comment: null
    };
  },

  methods: {
    decodeHtml: function decodeHtml(html) {
      var txt = document.createElement('textarea');
      txt.innerHTML = html;
      var val = txt.value;
      return val;
    },
    parseUrl: function parseUrl() {
      var jsonUrl = '';
      if (this.u.endsWith('/')) {
        jsonUrl = this.u.slice(0, -1) + '.json';
      } else {
        jsonUrl = this.u + '.json';
      }
      console.log(jsonUrl);
      this.jsonUrl = jsonUrl;
    },
    fetchComment: function fetchComment() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var fetcher, _ref2, _ref3, root, comment;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                fetcher = new RedditFetcher();
                _context2.next = 3;
                return fetcher.fetchComment(_this.jsonUrl);

              case 3:
                _ref2 = _context2.sent;
                _ref3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);
                root = _ref3[0];
                comment = _ref3[1];

                if (comment.data.children[0].kind === 't1') {
                  _this.comment = {
                    author: comment.data.children[0].data.author,
                    title: root.data.children[0].data.title,
                    text: comment.data.children[0].data.body_html,
                    permalink: 'https://reddit.com' + root.data.children[0].data.permalink,
                    context: root.data.children[0].data.url
                  };
                } else if (root.data.children[0].kind === 't1') {
                  console.log('IS ROOT EVER T1??');
                  _this.comment = {
                    author: root.data.children[0].data.author,
                    title: comment.data.children[0].data.title,
                    text: root.data.children[0].data.body,
                    permalink: 'https://reddit.com' + comment.data.children[0].data.permalink,
                    context: comment.data.children[0].data.url
                  };
                }
                _this.busy = false;

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    }
  },
  created: function created() {
    this.parseUrl();
  },
  mounted: function mounted() {
    this.fetchComment();
  }
});

/***/ }),

/***/ 218:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ 266:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 267:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 268:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 269:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 270:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 271:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 272:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 273:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 274:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 275:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 276:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 277:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 278:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 56,
	"./af.js": 56,
	"./ar": 63,
	"./ar-dz": 57,
	"./ar-dz.js": 57,
	"./ar-kw": 58,
	"./ar-kw.js": 58,
	"./ar-ly": 59,
	"./ar-ly.js": 59,
	"./ar-ma": 60,
	"./ar-ma.js": 60,
	"./ar-sa": 61,
	"./ar-sa.js": 61,
	"./ar-tn": 62,
	"./ar-tn.js": 62,
	"./ar.js": 63,
	"./az": 64,
	"./az.js": 64,
	"./be": 65,
	"./be.js": 65,
	"./bg": 66,
	"./bg.js": 66,
	"./bm": 67,
	"./bm.js": 67,
	"./bn": 68,
	"./bn.js": 68,
	"./bo": 69,
	"./bo.js": 69,
	"./br": 70,
	"./br.js": 70,
	"./bs": 71,
	"./bs.js": 71,
	"./ca": 72,
	"./ca.js": 72,
	"./cs": 73,
	"./cs.js": 73,
	"./cv": 74,
	"./cv.js": 74,
	"./cy": 75,
	"./cy.js": 75,
	"./da": 76,
	"./da.js": 76,
	"./de": 79,
	"./de-at": 77,
	"./de-at.js": 77,
	"./de-ch": 78,
	"./de-ch.js": 78,
	"./de.js": 79,
	"./dv": 80,
	"./dv.js": 80,
	"./el": 81,
	"./el.js": 81,
	"./en-SG": 82,
	"./en-SG.js": 82,
	"./en-au": 83,
	"./en-au.js": 83,
	"./en-ca": 84,
	"./en-ca.js": 84,
	"./en-gb": 85,
	"./en-gb.js": 85,
	"./en-ie": 86,
	"./en-ie.js": 86,
	"./en-il": 87,
	"./en-il.js": 87,
	"./en-nz": 88,
	"./en-nz.js": 88,
	"./eo": 89,
	"./eo.js": 89,
	"./es": 92,
	"./es-do": 90,
	"./es-do.js": 90,
	"./es-us": 91,
	"./es-us.js": 91,
	"./es.js": 92,
	"./et": 93,
	"./et.js": 93,
	"./eu": 94,
	"./eu.js": 94,
	"./fa": 95,
	"./fa.js": 95,
	"./fi": 96,
	"./fi.js": 96,
	"./fo": 97,
	"./fo.js": 97,
	"./fr": 100,
	"./fr-ca": 98,
	"./fr-ca.js": 98,
	"./fr-ch": 99,
	"./fr-ch.js": 99,
	"./fr.js": 100,
	"./fy": 101,
	"./fy.js": 101,
	"./ga": 102,
	"./ga.js": 102,
	"./gd": 103,
	"./gd.js": 103,
	"./gl": 104,
	"./gl.js": 104,
	"./gom-latn": 105,
	"./gom-latn.js": 105,
	"./gu": 106,
	"./gu.js": 106,
	"./he": 107,
	"./he.js": 107,
	"./hi": 108,
	"./hi.js": 108,
	"./hr": 109,
	"./hr.js": 109,
	"./hu": 110,
	"./hu.js": 110,
	"./hy-am": 111,
	"./hy-am.js": 111,
	"./id": 112,
	"./id.js": 112,
	"./is": 113,
	"./is.js": 113,
	"./it": 115,
	"./it-ch": 114,
	"./it-ch.js": 114,
	"./it.js": 115,
	"./ja": 116,
	"./ja.js": 116,
	"./jv": 117,
	"./jv.js": 117,
	"./ka": 118,
	"./ka.js": 118,
	"./kk": 119,
	"./kk.js": 119,
	"./km": 120,
	"./km.js": 120,
	"./kn": 121,
	"./kn.js": 121,
	"./ko": 122,
	"./ko.js": 122,
	"./ku": 123,
	"./ku.js": 123,
	"./ky": 124,
	"./ky.js": 124,
	"./lb": 125,
	"./lb.js": 125,
	"./lo": 126,
	"./lo.js": 126,
	"./lt": 127,
	"./lt.js": 127,
	"./lv": 128,
	"./lv.js": 128,
	"./me": 129,
	"./me.js": 129,
	"./mi": 130,
	"./mi.js": 130,
	"./mk": 131,
	"./mk.js": 131,
	"./ml": 132,
	"./ml.js": 132,
	"./mn": 133,
	"./mn.js": 133,
	"./mr": 134,
	"./mr.js": 134,
	"./ms": 136,
	"./ms-my": 135,
	"./ms-my.js": 135,
	"./ms.js": 136,
	"./mt": 137,
	"./mt.js": 137,
	"./my": 138,
	"./my.js": 138,
	"./nb": 139,
	"./nb.js": 139,
	"./ne": 140,
	"./ne.js": 140,
	"./nl": 142,
	"./nl-be": 141,
	"./nl-be.js": 141,
	"./nl.js": 142,
	"./nn": 143,
	"./nn.js": 143,
	"./pa-in": 144,
	"./pa-in.js": 144,
	"./pl": 145,
	"./pl.js": 145,
	"./pt": 147,
	"./pt-br": 146,
	"./pt-br.js": 146,
	"./pt.js": 147,
	"./ro": 148,
	"./ro.js": 148,
	"./ru": 149,
	"./ru.js": 149,
	"./sd": 150,
	"./sd.js": 150,
	"./se": 151,
	"./se.js": 151,
	"./si": 152,
	"./si.js": 152,
	"./sk": 153,
	"./sk.js": 153,
	"./sl": 154,
	"./sl.js": 154,
	"./sq": 155,
	"./sq.js": 155,
	"./sr": 157,
	"./sr-cyrl": 156,
	"./sr-cyrl.js": 156,
	"./sr.js": 157,
	"./ss": 158,
	"./ss.js": 158,
	"./sv": 159,
	"./sv.js": 159,
	"./sw": 160,
	"./sw.js": 160,
	"./ta": 161,
	"./ta.js": 161,
	"./te": 162,
	"./te.js": 162,
	"./tet": 163,
	"./tet.js": 163,
	"./tg": 164,
	"./tg.js": 164,
	"./th": 165,
	"./th.js": 165,
	"./tl-ph": 166,
	"./tl-ph.js": 166,
	"./tlh": 167,
	"./tlh.js": 167,
	"./tr": 168,
	"./tr.js": 168,
	"./tzl": 169,
	"./tzl.js": 169,
	"./tzm": 171,
	"./tzm-latn": 170,
	"./tzm-latn.js": 170,
	"./tzm.js": 171,
	"./ug-cn": 172,
	"./ug-cn.js": 172,
	"./uk": 173,
	"./uk.js": 173,
	"./ur": 174,
	"./ur.js": 174,
	"./uz": 176,
	"./uz-latn": 175,
	"./uz-latn.js": 175,
	"./uz.js": 176,
	"./vi": 177,
	"./vi.js": 177,
	"./x-pseudo": 178,
	"./x-pseudo.js": 178,
	"./yo": 179,
	"./yo.js": 179,
	"./zh-cn": 180,
	"./zh-cn.js": 180,
	"./zh-hk": 181,
	"./zh-hk.js": 181,
	"./zh-tw": 182,
	"./zh-tw.js": 182
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 281;

/***/ })

},[206]);


// WEBPACK FOOTER //
// static/js/app.21c6b26e920c5d837e7a.js